import Cache from './index';

export default { path: '/home/trade/cache', component: Cache };
